<template>
    <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.235 27.9h8.807v-9.598H9.878v-3.164h3.164v-3.955a3.96 3.96 0 0 1 3.955-3.955h3.955v3.164h-3.164c-.873 0-1.582.71-1.582 1.582v3.164h4.603l-.527 3.164h-4.076V27.9h7.119a3.96 3.96 0 0 0 3.955-3.955V4.855A3.96 3.96 0 0 0 23.325.9H4.235A3.96 3.96 0 0 0 .28 4.855v19.09A3.96 3.96 0 0 0 4.235 27.9zM1.862 4.855a2.376 2.376 0 0 1 2.373-2.373h19.09a2.376 2.376 0 0 1 2.373 2.373v19.09a2.376 2.376 0 0 1-2.373 2.373h-5.537v-6.434h3.834l1.055-6.328h-4.89v-1.582h4.747V5.646h-5.537a5.543 5.543 0 0 0-5.537 5.537v2.373H8.296v6.328h3.164v6.434H4.235a2.376 2.376 0 0 1-2.373-2.373V4.855z" fill="#9A1F35" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {

}
</script>
